import script from "./SchedulingContextCustomizationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchedulingContextCustomizationModal.vue?vue&type=script&setup=true&lang=ts"

import "./SchedulingContextCustomizationModal.vue?vue&type=style&index=0&id=b7048d8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7048d8a"]])

export default __exports__